import afterUpdate from '../modules/afterUpdate';
import {querySelector } from '../functions/querySelectors';
import { xhrLoad } from '../functions/xhrLoad';
import insertScript from '../functions/insertScript';
import { setListenersFromSelector } from '../functions/listeners';
import { createLoader, DIV_CLASS } from '../functions/createLoader';

const PAGE_CLASS = 'js-ajax-load-page';
const PAGE_INIT_CLASS = 'jalp-init';
const PAGE_BTN_CLASS = 'js-ajax-btn-page';
const WRAP_CLASS = 'js-ajax-wrap';
const ACTIVE_WRAP_CLASS = 'js-ajax-wrap--active';
const ITEMS_CLASS = 'js-ajax-items';

let getWrapper = function(element) {
  return element.closest(`.${WRAP_CLASS}`);
};

let getActiveWrapper = function() {
  return querySelector(`.${ACTIVE_WRAP_CLASS}`);
};

let loadOnePage = function(response) {
  let wrap = getActiveWrapper();
  let btnPage = querySelector(`.${PAGE_BTN_CLASS}`, wrap);

  btnPage.parentNode.removeChild(btnPage);

  insertScript(response);
  querySelector(`.${ITEMS_CLASS}`, wrap).insertAdjacentHTML('beforeend', response);

  wrap.classList.remove(ACTIVE_WRAP_CLASS);
  setPageLinks();
};

let failPage = function(response) {
  let wrapper = getActiveWrapper();

  wrapper.classList.remove(ACTIVE_WRAP_CLASS);
};

let loadPageClick = function(event) {
  event.preventDefault();

  let wrap = getWrapper(this);
  let btnPage = querySelector(`.${PAGE_BTN_CLASS}`, wrap);

  wrap.classList.add(ACTIVE_WRAP_CLASS);

  if (!querySelector(`.${DIV_CLASS}`, btnPage)) {
    btnPage.appendChild(createLoader());
  }

  xhrLoad(
    this.getAttribute('href'),
    loadOnePage,
    failPage
  );
};

let setPageLinks = function() {
  setListenersFromSelector(
    `.${PAGE_CLASS}`,
    PAGE_INIT_CLASS,
    loadPageClick
  );
};

export function pagingPage() {
  afterUpdate.add(setPageLinks)();
};
